import merge from 'lodash/merge';
import _compact from 'lodash/compact';
import { takeLatest, put, select } from 'redux-saga/effects';
import { mapskus } from '../../actions/fulfillmentActions/getItemsBySkuMap';
import { FULFILLMENT_METHOD_APPLIANCE, LIFE_CYCLE_EVENT_CONFIGURATOR_DATA, LIFE_CYCLE_EVENT_CONFIGURATOR_LOADING } from '../../actions/hydration/constants';
import { cartProducts, createItemDetails } from '../../actions/cartActions/__createItemDetailsPerStore';
import safeSaga from '../safeSaga';
import configurationCartSelector from '../../selectors/configurationCart/configurationCartSelector';
import { ADD_CONFIGURATION_TO_CART, UPDATE_CART_PRODUCT_CONFIGURATION } from '../../actions/actionTypes';

function* addConfigToCart() {
  const state = yield select(configurationCartSelector);
  const {
    allowDuplicateSubSkus,
    isMajorAppliance,
    product,
    productInfoNonDefault,
    cartData,
    thdStoreInfo,
    config,
    skuMap,
  } = state;
  const { fulfillment, configuration } = product;
  const { subSkus } = skuMap;
  const items = mapskus(productInfoNonDefault, config, skuMap);
  const unavailableItemDetails = [];

  const mappedItemDetails = cartProducts(allowDuplicateSubSkus, subSkus, cartData).map(
    (cartProduct) => createItemDetails(
      cartProduct,
      items,
      thdStoreInfo,
      subSkus,
      fulfillment,
      productInfoNonDefault,
      configuration,
      isMajorAppliance,
      allowDuplicateSubSkus
    )
  );

  if (mappedItemDetails?.length <= 0) {
    items.forEach((x) => {
      unavailableItemDetails.push({
        itemId: `${x.itemId}`,
        storeId: thdStoreInfo?.storeNumber,
        zipCode: thdStoreInfo?.zipcode,
        quantity: 1,
        fulfillmentMethod: isMajorAppliance ? FULFILLMENT_METHOD_APPLIANCE : configuration?.cart?.[0]?.fulfillmentMethod
      });
    });
  }

  const itemDetails = mappedItemDetails?.length > 0
    ? mappedItemDetails
    : unavailableItemDetails;
  const cart = configuration?.cart;

  if (cart !== itemDetails && itemDetails.length > 0) {
    // eslint-disable-next-line no-unused-expressions
    items?.length !== cart?.length ? delete configuration?.cart : false;
    // TECH DEBT: This will cause anything unavailable/out of stock to be excluded from carting
    // So customer could potentially select a choice that is out of stock then cart and not see that line item
    const itemIdsThatHaveFulfillment = _compact(mappedItemDetails).map((mappedItem) => Number(mappedItem.itemId));
    const itemsWithFulfillment = _compact(items).filter((item) => itemIdsThatHaveFulfillment.indexOf(item.itemId) >= 0);

    const parsedData = merge(
      {},
      { product },
      { product: {
        configuration: {
          deliveryTime: configuration?.deliveryTime,
          cart: _compact(itemDetails),
          items: itemsWithFulfillment,
        }
      } }
    );

    LIFE_CYCLE_EVENT_BUS.trigger(LIFE_CYCLE_EVENT_CONFIGURATOR_DATA, { configuratorData: parsedData });
    LIFE_CYCLE_EVENT_BUS.trigger(LIFE_CYCLE_EVENT_CONFIGURATOR_LOADING, false);

    yield put({
      type: UPDATE_CART_PRODUCT_CONFIGURATION,
      data: parsedData,
    });
  }
  return null;
}

export default function* addConfigurationToCartSaga() {
  yield takeLatest(ADD_CONFIGURATION_TO_CART, safeSaga(addConfigToCart));
}
